/**
 * ModulesPage — list of all modules with filters.
 */

import { useFilteredModules } from '../state/gallery-store';
import { ModuleCard } from '../components/ModuleCard';
import { FilterBar } from '../components/FilterBar';
import './ListPage.css';

export function ModulesPage() {
  const modules = useFilteredModules();

  return (
    <div className="list-page">
      <header className="list-page__header">
        <h1 className="list-page__title">Modules</h1>
        <span className="list-page__count">{modules.length}</span>
      </header>
      <FilterBar />
      {modules.length === 0 ? (
        <p className="list-page__empty">No modules match the current filters.</p>
      ) : (
        <div className="list-page__grid">
          {modules.map((m) => (
            <ModuleCard key={m.id} module={m} />
          ))}
        </div>
      )}
    </div>
  );
}
